/* eslint-disable no-undef */
import { Stack } from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'
import { GoogleLogin } from '@react-oauth/google'
import axios from 'axios'
import CircularIndeterminate from 'components/CircularIndeterminate'
import Cookies from 'js-cookie'
import { useLoadingStore } from 'stores/loading.store'
import useCollapseDrawer from '../hooks/useCollapseDrawer'

const APP_BAR_MOBILE = 64
const APP_BAR_DESKTOP = 92

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
})

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}))

const LoginPage = () => {
  const theme = useTheme()
  const { collapseClick } = useCollapseDrawer()
  const setIsGlobalLoading = useLoadingStore((state) => state.setIsGlobalLoading)
  return (
    <RootStyle>
      <MainStyle
        sx={{
          transition: theme.transitions.create('margin', {
            duration: theme.transitions.duration.complex
          }),
          ...(collapseClick && {
            ml: '102px'
          })
        }}
      >
        <Stack direction="column" justifyContent="center" alignItems="center">
          <CircularIndeterminate />
          <GoogleLogin
            onSuccess={(credentialResponse) => {
              setIsGlobalLoading(true)
              axios
                .post(
                  `${process.env.REACT_APP_BACKEND_API_URL}/auth/login`,
                  {
                    credential: credentialResponse.credential
                  },
                  {
                    withCredentials: true // Đảm bảo gửi cookies nếu cần
                  }
                )
                .then((response) => {
                  Cookies.set('hrme_token', response.data.token, {
                    expires: 60 * 60 * 24 * 7 - 60 * 60,
                    path: '/'
                  })

                  localStorage.setItem(
                    'hrme_user',
                    JSON.stringify({
                      name: response.data.name,
                      email: response.data.email,
                      staffCode: response.data.staffCode,
                      position: response.data.position
                    })
                  )
                  setTimeout(() => {
                    window.location.href = '/'
                  }, 100)
                  setIsGlobalLoading(false)
                })
                .catch((error) => {
                  setIsGlobalLoading(false)
                  console.log(error)
                })
            }}
            onError={() => {
              setIsGlobalLoading(false)
            }}
          />
        </Stack>
      </MainStyle>
    </RootStyle>
  )
}

export default LoginPage
